import { createElement as _createElement } from "react";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import '../../../styles/custom-table-style.css';
import React from 'react';
import { useTable } from 'react-table';
import VnButton from '@ui/components/VnButton';
import { arrowDown, arrowUp, funnelOutline } from 'ionicons/icons';
import { IonIcon } from '@ionic/react';
const InStockArticalTable = ({ articals, onRowClick, onSorting, onFilter, defaultSortingCriteria }) => {
    const [sortingCriteria, setSortingCriteria] = useState(null);
    const [showFilters, setShowFilters] = useState(false);
    const [filterValues, setFilterValues] = useState({});
    const columns = React.useMemo(() => [
        { Header: 'Artikelnr', accessor: 'articleNumber' },
        { Header: 'Naam', accessor: 'name' },
        { Header: 'Artikel groep', accessor: 'articleGroup' },
        { Header: 'Merk', accessor: 'brand' },
        { Header: 'Type', accessor: 'type' },
        { Header: 'Gegevens', accessor: 'data' },
        { Header: 'Leveranciers', accessor: 'supplierName' },
        { Header: 'Artikelnr Leveranciers', accessor: 'supplierArticleNumber' }
    ], []);
    const data = React.useMemo(() => articals || [], [articals]);
    const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } = useTable({ columns, data });
    useEffect(() => {
        const newSortingCriteria = {
            sortColumnKey: defaultSortingCriteria.sortColumnKey,
            sortDirection: defaultSortingCriteria.sortDirection
        };
        setSortingCriteria(newSortingCriteria);
    }, []);
    const handleSort = (column) => {
        setSortingCriteria((prevSortingCriteria) => {
            const currentSortDirection = prevSortingCriteria?.sortDirection || 'asc';
            const sortDirection = column.id === prevSortingCriteria?.sortColumnKey ? (currentSortDirection === 'asc' ? 'desc' : 'asc') : 'asc';
            const newSortingCriteria = {
                sortColumnKey: column.id,
                sortDirection: sortDirection
            };
            onSorting(newSortingCriteria);
            return newSortingCriteria;
        });
    };
    const handleFilterChange = (columnId, value) => {
        setFilterValues((prevFilterValues) => {
            var updatedFilterValues = {
                ...prevFilterValues,
                [columnId]: value
            };
            if (typeof value === 'string' && value.length >= 2) {
                applyFilter(updatedFilterValues);
            }
            else if (value instanceof Date) {
                applyFilter(updatedFilterValues);
            }
            else if (typeof value != 'string' && typeof value != typeof Date) {
                applyFilter(updatedFilterValues);
            }
            if (typeof value === 'string' && value.length == 0) {
                const resetFilterValue = {
                    ...prevFilterValues,
                    [columnId]: null
                };
                updatedFilterValues = resetFilterValue;
                applyFilter(resetFilterValue);
            }
            return updatedFilterValues;
        });
    };
    const applyFilter = (filterValues) => {
        onFilter(filterValues);
    };
    const clearFilters = () => {
        const nullFilterValues = Object.fromEntries(Object.keys(filterValues).map((key) => [key, null]));
        setFilterValues({});
        setShowFilters(!showFilters);
        onFilter(nullFilterValues);
    };
    const handleRowClick = (row) => {
        onRowClick(row.original.id);
    };
    return (_jsxs(_Fragment, { children: [_jsx("div", { className: 'd-flex justify-content-end mb-2 vn-filter-button-container', children: _jsx("div", { className: 'filter-header-container', children: _jsx(VnButton, { style: { borderRadius: '8px', minWidth: '41px', height: '37px', width: '20px' }, customClassName: !showFilters ? 'vn-header-buttons' : 'vn-header-buttons vn-table-filter-remove-button', icon: funnelOutline, customIconClassName: 'vn-filter-button-icon', mode: 'danger', onClick: () => {
                            !showFilters ? setShowFilters(!showFilters) : clearFilters();
                        } }) }) }), _jsx("div", { className: 'custom-table-container', children: _jsx("div", { className: 'vn-table-container', children: _jsx("div", { className: 'vn-main', children: _jsxs("table", { ...getTableProps(), className: 'table', children: [_jsx("thead", { className: 'vn-table-thead', children: headerGroups.map((headerGroup) => (_jsxs(React.Fragment, { children: [_jsx("tr", { ...headerGroup.getHeaderGroupProps(), className: 'vn-custom-grid-header-card', children: headerGroup.headers.map((column) => (_jsx("th", { ...column.getHeaderProps(), style: { cursor: 'pointer', padding: '4px 4px' }, children: _jsxs("div", { onClick: () => handleSort(column), className: 'vn-grid-header-sort-inline header-caption', children: [column.render('Header'), sortingCriteria && sortingCriteria.sortColumnKey === column.id && (_jsx("span", { children: sortingCriteria.sortDirection === 'asc' ? (_jsx(IonIcon, { icon: arrowUp, className: 'ml-1 vn-grid-sorting-icon' })) : (_jsx(IonIcon, { icon: arrowDown, className: 'ml-1 vn-grid-sorting-icon' })) }))] }) }))) }), showFilters && (_jsx("tr", { children: headerGroup.headers.map((column) => (_jsx("td", { style: { borderBottomColor: '#80808047' }, children: _jsx("div", { style: { width: '140px' }, children: _jsx("input", { className: 'form-control vn-Input', type: 'text', value: filterValues[column.id] || '', onChange: (e) => {
                                                                if (/^\d*$/.test(e.target.value) && column.id == 'debtorNumber') {
                                                                    //takes numbers onlt in input
                                                                    handleFilterChange(column.id, e.target.value);
                                                                }
                                                                else if (column.id != 'debtorNumber') {
                                                                    handleFilterChange(column.id, e.target.value);
                                                                }
                                                            } }) }) }, column.id ? column.id : 0))) }))] }, headerGroup.id ? headerGroup.id : 0))) }), rows && data && (_jsx("tbody", { ...getTableBodyProps(), className: 'vn-table-tbody', children: rows.map((row) => {
                                        prepareRow(row);
                                        return (_jsx("tr", { ...row.getRowProps(), style: { cursor: 'pointer' }, onClick: () => handleRowClick(row), children: row.cells.map((cell, index) => (_createElement("td", { ...cell.getCellProps(), key: index ? index : 0, style: { padding: '4px' } },
                                                _jsx("span", { children: cell.render('Cell') })))) }));
                                    }) }))] }) }) }) })] }));
};
export default InStockArticalTable;
